export default __webpack_public_path__ + "static/media/34.38133010.svg";